import { useQuery } from "@tanstack/react-query";
import resumeRepositoryService from "../services/resumeRepositoryService";
import { RESUME_QUERY_KEYS } from "./useResumeSearch";

export const useResumeDetails = (resumeId) =>
  useQuery({
    queryKey: [RESUME_QUERY_KEYS.detail, resumeId],
    queryFn: () => resumeRepositoryService.getResume(resumeId),
    enabled: Boolean(resumeId),
  });

export const useResumeVersions = (resumeId) =>
  useQuery({
    queryKey: [RESUME_QUERY_KEYS.versions, resumeId],
    queryFn: () => resumeRepositoryService.getVersionTimeline(resumeId),
    enabled: Boolean(resumeId),
  });
